import React, { useState } from 'react';
import './PartsList.css';

const PartsList = ({ parts }) => {
  const [isOpen, setIsOpen] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth >= 900;
    }
    return true;
  });

  if (!parts || parts.length === 0) {
    return null;
  }

  return (
    <div className="parts-list-container" id="parts-list-section">
      <button
        className="parts-list-toggle"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        aria-expanded={isOpen}
      >
        <span>Parts List ({parts.length})</span>
        <span className="toggle-icon">{isOpen ? '▼' : '▶'}</span>
      </button>

      {isOpen && (
        <div className="parts-list-content">
          <table className="parts-table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Selection</th>
                <th>Price Modifier</th>
              </tr>
            </thead>
            <tbody>
              {parts.map((part, index) => (
                <tr key={index}>
                  <td className="part-category">{part.stepName}</td>
                  <td className="part-name">{part.optionName}</td>
                  <td className="part-price">
                    {part.price > 0 ? `+$${part.price.toFixed(2)}` : 'Included'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PartsList;
